export const INIT_PAGINATOR = 'INIT_PAGINATOR'
export const SET_PAGE = 'SET_PAGE'

export const LOAD_PAGINATED_PAGE = 'LOAD_PAGINATED_PAGE'
export const LOAD_PAGINATED_PAGE_LOADING = 'LOAD_PAGINATED_PAGE_LOADING'
export const LOAD_PAGINATED_PAGE_ERROR = 'LOAD_PAGINATED_PAGE_ERROR'
export const LOAD_PAGINATED_PAGE_SUCCESS = 'LOAD_PAGINATED_PAGE_SUCCESS'



// WEBPACK FOOTER //
// ./src/services/paginator/constants.js